export const sortPersonList = (personList) => {
    personList.sort((person1, person2) => {
        if (person1.firstName.toLowerCase() < person2.firstName.toLowerCase()) {
            return -1
        }
        if (person1.firstName.toLowerCase() > person2.firstName.toLowerCase()) {
            return 1
        }
        return 0;
    });
}

export const createPersonDropdownDisplayValue = (person, showOrganisation, showOrganisationRole) => {
    let {firstName, lastName, organisation, organisationRole} = person;

    let displayValue = `${firstName} ${lastName}`;

    if (showOrganisation) {
        displayValue = `${displayValue} from ${organisation ? organisation : "N/A"}`;
    }

    if (showOrganisationRole) {
        displayValue = `${displayValue} (${organisationRole ? organisationRole : "N/A"})`;
    }

    return displayValue;
}
